import useLocalStorage from "@rehooks/local-storage";
import { CheckedSteps } from "./Wizard";

/**
 * There may be instances where we need to call this hook before we have a
 * resource ID. The rules of hooks prevent us from using an early return, so
 * instead we just use a placeholder string when the resource ID is undefined.
 * This means that we might end up with some extra data in localStorage which
 * ultimately gets ignored.
 */
const EMPTY_RESOURCE_ID = "EMPTY";

const noop = () => {};

export function useWizard(
  resourceType: string,
  resourceId = EMPTY_RESOURCE_ID
): {
  isHidden: boolean;
  setIsHidden: React.Dispatch<boolean>;
  checkedSteps: CheckedSteps;
  setCheckedSteps: React.Dispatch<CheckedSteps>;
  tabIndex: number;
  setTabIndex: React.Dispatch<number>;
} {
  const baseKey = `wizard-${resourceType}-${resourceId}`;
  const [isHidden, setIsHidden] = useLocalStorage<boolean>(`${baseKey}-hidden`, false);

  const [checkedSteps, setCheckedSteps] = useLocalStorage<CheckedSteps>(`${baseKey}-checked`, {});

  const [tabIndex, setTabIndex] = useLocalStorage<number>(`${baseKey}-index`, 0);

  return resourceId === EMPTY_RESOURCE_ID
    ? {
        isHidden: true,
        setIsHidden: noop,
        checkedSteps: {},
        setCheckedSteps: noop,
        tabIndex: 0,
        setTabIndex: noop,
      }
    : {
        isHidden,
        setIsHidden,
        checkedSteps,
        setCheckedSteps,
        tabIndex,
        setTabIndex,
      };
}
